import { FilterInterface } from '@accounting/interfaces/accesses-report';

export const filters: FilterInterface = {
  period: {
    label: 'reports.sales_report.period.label',
    placeholder: 'reports.sales_report.period.placeholder',
    options: [
      {
        text: 'reports.sales_report.period.option.today',
        value: 'today',
      },
      {
        text: 'reports.sales_report.period.option.yesterday',
        value: 'yesterday',
      },
      {
        text: 'reports.sales_report.period.option.this_week',
        value: 'this_week',
      },
      {
        text: 'reports.sales_report.period.option.previous_week',
        value: 'previous_week',
      },
      {
        text: 'reports.sales_report.period.option.this_month',
        value: 'this_month',
      },
      {
        text: 'reports.sales_report.period.option.previous_month',
        value: 'previous_month',
      },
      {
        text: 'reports.sales_report.period.option.this_trimester',
        value: 'this_trimester',
      },
      {
        text: 'reports.sales_report.period.option.previous_trimester',
        value: 'previous_trimester',
      },
      {
        text: 'reports.sales_report.period.option.this_year',
        value: 'this_year',
      },
      {
        text: 'reports.sales_report.period.option.previous_year',
        value: 'previous_year',
      },
      {
        text: 'reports.sales_report.period.option.custom',
        value: 'custom',
      },
    ],
  },
  date_from: '',
  date_to: '',
};

export const grouping = {
  label: 'reports.accesses_report.grouping.label',
  placeholder: 'reports.accesses_report.grouping.placeholder',
  options: [
    {
      text: 'reports.accesses_report.grouping.option.analytic_account',
      value: 'analytic_account',
    },
    {
      text: 'reports.accesses_report.grouping.option.article',
      value: 'article',
    },
  ],
};

export const chartBackgroundColor: string[] = [
  '#FF6384',
  '#36A2EB',
  '#FFCE56',
  '#4BC0C0',
  '#9966FF',
  '#FF9933',
  '#339933',
  '#FF6666',
  '#66CCCC',
  '#FFCC00',
  '#663366',
  '#CC6666',
  '#999966',
  '#FF9966',
  '#66CC66',
  '#CC6699',
  '#996699',
  '#FF6666',
  '#6699CC',
  '#FF6666',
  '#CCCC66',
  '#993366',
  '#3399CC',
  '#FF6666',
  '#66CC99',
  '#CC9966',
  '#996633',
  '#3366CC',
  '#FF6666',
  '#CC6666',
  '#FF6384',
  '#36A2EB',
  '#FFCE56',
  '#4BC0C0',
  '#9966FF',
  '#FF9933',
  '#339933',
  '#FF6666',
  '#66CCCC',
  '#FFCC00',
  '#663366',
  '#CC6666',
  '#999966',
  '#FF9966',
  '#66CC66',
  '#CC6699',
  '#996699',
  '#FF6666',
  '#6699CC',
  '#FF6666',
  '#CCCC66',
  '#993366',
  '#3399CC',
  '#FF6666',
  '#66CC99',
  '#CC9966',
  '#996633',
  '#3366CC',
  '#FF6666',
  '#CC6666',
];
